/**
 * get current palette contrast text
 */
export function paletteContrastText(colorFn) {
    return function (_a) {
        var theme = _a.theme;
        return theme.palette.getContrastText(colorFn({ theme: theme }));
    };
}
